<template>
  <div class="container pt-100">
    <div class="row">
      <div class="col-xl-10 offset-xl-1">
        <div class="row justify-content-center pb-70">
          <div class="col-lg-4 col-md-6">
            <div class="contact-card text-center">
              <span
                class="contact-icon d-flex flex-column align-items-center justify-content-center round-6 mx-auto"
              >
                <img src="../../assets/img/icons/phone-icon.svg" alt="Image" />
              </span>
              <span>24/7 Free</span>
              <h3 class="fs-26">Phone Number</h3>
              <a href="tel:939939199999" class="d-block">+939 9391 999 99</a>
              <a href="tel:434245684334" class="d-block">+434 2456 843 34</a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="contact-card text-center">
              <span
                class="contact-icon d-flex flex-column align-items-center justify-content-center round-6 mx-auto"
              >
                <img src="../../assets/img/icons/chat.svg" alt="Image" />
              </span>
              <span>Messages</span>
              <h3 class="fs-26">Send Message</h3>
              <a href="mailto:support@mazii.app" class="d-block">
                support@mazii.app
              </a>
              <a href="mailto:hello@mazii.app" class="d-block">hello@mazii.app</a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="contact-card text-center">
              <span
                class="contact-icon d-flex flex-column align-items-center justify-content-center round-6 mx-auto"
              >
                <img src="../../assets/img/icons/phone-icon.svg" alt="Image" />
              </span>
              <span>Location</span>
              <h3 class="fs-26">Our Location</h3>
              <p class="d-block mb-0 px-xxl-5">
                56/TY Hirsing Tower, Jhonson Avenue, Nordin, USA
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactInfo",
};
</script>

<style lang="scss" scoped>
.contact-card {
  margin-bottom: 30px;
  .contact-icon {
    width: 88px;
    height: 82px;
    margin-bottom: 12px;
    background: linear-gradient(92deg, #a861f9 0%, #8145d5 100%);
  }
  h3 {
    margin: 5px 0 10px;
  }
}
</style>